import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import '../styles/v3-pages.css';
// import { Smiley } from './motifs';

// TODO: replace these placeholder hobby photos with real ones (overwrite the files at public/assets/images/hobbies/):
//   singing.jpg → duplicate of LeadingEclubAsVP.jpg (placeholder)
//   gaming.jpg  → duplicate of UsingVR.jpg (real fit)
//   reading.jpg → duplicate of CandidAtIDE.jpg (placeholder)
//   hiking.jpg  → duplicate of ParticipatingInWoW2024.jpg (placeholder)
//   content.jpg → duplicate of HostingIDEBootcamp.jpg (real fit)
//   speaking.jpg → duplicate of GDGSpeaking.jpg (real fit)
const HOBBIES = [
  { id: 'singing', label: 'SINGING', img: '/assets/images/hobbies/singing.jpg', init: { top: '8%', left: '6%', rotate: -5 } },
  { id: 'gaming', label: 'GAMING', img: '/assets/images/hobbies/gaming.jpg', init: { top: '12%', left: '52%', rotate: 4 } },
  { id: 'acting', label: 'ACTING', img: '/assets/images/hobbies/reading.jpg', init: { top: '42%', left: '34%', rotate: -3 } },
  { id: 'content', label: 'CONTENT', img: '/assets/images/hobbies/content.jpg', init: { top: '58%', left: '10%', rotate: -2 } },
];

const SPEAKING_LINKS = [
  { label: 'Entrepreneurs Club', url: 'https://www.instagram.com/entrepreneursclub_gitam/?hl=en' },
  { label: 'GDG Hackathon', url: 'https://www.linkedin.com/posts/vijaykagupati_androidxr-gdg-wow2025-activity-7352963484294238210-_1g_' },
  { label: 'XR Bootcamp', url: 'https://www.linkedin.com/posts/vijaykagupati_activity-7350696074447122432-M7cf' },
];

function HobbyDesktop() {
  const canvasRef = useRef(null);
  return (
    <div className="v3-hobby-desktop" ref={canvasRef}>
      <div className="v3-hobby-desktop__label">[ DESKTOP · drag me ]</div>
      {HOBBIES.map((h, i) => (
        <motion.div
          key={h.id}
          className="v3-hobby-card"
          drag
          dragConstraints={canvasRef}
          dragElastic={0.18}
          whileTap={{ scale: 0.98 }}
          whileHover={{ y: -2 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.5 + i * 0.06, ease: [0.22, 1, 0.36, 1] }}
          style={{ position: 'absolute', top: h.init.top, left: h.init.left, rotate: h.init.rotate }}
        >
          <img src={h.img} alt={h.label} className="v3-hobby-card__img" draggable={false} />
          <div className="v3-hobby-card__caption">{h.label}</div>
        </motion.div>
      ))}
      <motion.div
        className="v3-hobby-card v3-hobby-card--speaking"
        drag
        dragConstraints={canvasRef}
        dragElastic={0.18}
        whileTap={{ scale: 0.98 }}
        whileHover={{ y: -2 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.85, ease: [0.22, 1, 0.36, 1] }}
        style={{ position: 'absolute', top: '55%', left: '64%', rotate: 3 }}
      >
        <div className="v3-hobby-card__caption v3-hobby-card__caption--header">SPEAKING</div>
        <ul className="v3-hobby-card__links">
          {SPEAKING_LINKS.map((s) => (
            <li key={s.url}>
              <a href={s.url} target="_blank" rel="noopener noreferrer" onPointerDown={(e) => e.stopPropagation()}>
                {s.label}
              </a>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  );
}

function About() {
  const staggerConfig = {
    initial: { opacity: 0, y: 12 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] }
  };

  return (
    <section className="v3-about" id="about" data-aos="fade-up" data-aos-duration="1000">
      <motion.div className="v3-about-eyebrow" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0 }}>
        [ ABOUT · V.K ]
      </motion.div>

      <motion.h1 className="v3-about-title" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.06 }}>
        About me.
      </motion.h1>

      <motion.p className="v3-about-intro" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.12 }}>
        I build interactive experiences, and I'm obsessive about measuring what holds people's attention. Day to day I write production Unity and C# for Meta Quest, Android, Windows: multiplayer, rendering and performance, editor tooling.
      </motion.p>

      <motion.div {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.24 }}>
        <HobbyDesktop />
      </motion.div>
      {/* 
      <motion.div
        className="v3-about-pull-quote"
        initial={{ opacity: 0, y: 16, rotate: 0 }}
        whileInView={{ opacity: 1, y: 0, rotate: -2 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.4, delay: 0.42, ease: [0.22, 1, 0.36, 1] }}
      >
        "Motivated to conceptualize and develop captivating experiences through design and technology."
      </motion.div>

      <motion.div
        className="v3-about-smiley"
        style={{ position: 'relative', right: 0, top: 0, marginTop: 'var(--s-12)' }}
        animate={{ rotate: [-3, 3, -3] }}
        transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
      >
        <Smiley color="var(--tomato)" />
      </motion.div> */}
    </section>
  );
}

export default About;